// Central site + doctor + clinic data for Advanced ENT Surgery Centre, Varanasi

export const DOCTOR = {
  name: "Dr. Sanjay Teza",
  qualifications: "MBBS, MS (ENT)",
  title: "Senior ENT Specialist & ENT Surgeon",
  experienceYears: "25+",
  patientsTreated: "3,00,000+",
  bio: "Dr. Sanjay Teza is a senior ENT Specialist and ENT Surgeon based in Varanasi with over 25 years of clinical experience in the diagnosis and treatment of disorders affecting the ear, nose, throat, head and neck. Throughout his career he has treated more than three lakh patients and has developed expertise in advanced ear surgeries, Functional Endoscopic Sinus Surgery (FESS), septoplasty, microscopic ear surgery, thyroid surgery and other complex ENT procedures.",
  philosophy: "He believes in evidence-based, ethical and patient-centric care, focusing on accurate diagnosis, transparent treatment planning and long-term outcomes.",
  education: [
    "MBBS — Banaras Hindu University (BHU), Varanasi",
    "MS (ENT) — Banaras Hindu University (BHU), Varanasi",
    "Senior Residency — Batra Hospital, New Delhi (Advanced ENT & Head & Neck Surgery)",
  ],
  awards: [
    "Health Legends Award",
    "Dainik Jagran Wellness+ Healthcare Award",
  ],
  memberships: [
    "Indian Medical Association (IMA)",
    "Association of Otolaryngologists of India (AOI)",
  ],
};

export const CONTACT = {
  phone: "+91 93369 22349",
  phoneRaw: "919336922349",
  whatsapp: "919336922349",
  email: "drsanjayteza@gmail.com",
};

export const WHATSAPP_BASE = `https://wa.me/${CONTACT.whatsapp}`;

export const CLINICS = [
  {
    name: "Dr. Sanjay Teza ENT Center",
    profile: "Best ENT Doctor in Varanasi",
    address:
      "20, Shakumbhari Complex, Peace Point Road, Near Chetmani Chauraha, Anandbagh, Bhelupur, Varanasi, Uttar Pradesh 221001",
    timings: "Mon–Sat: 5:00 PM – 7:00 PM",
    mapQuery:
      "Dr Sanjay Teza ENT Center, Shakumbhari Complex, Bhelupur, Varanasi",
    reviewsUrl: "https://maps.app.goo.gl/hvVKDXjac2SKmBxy8",
  },
  {
    name: "Vardaan Hospital",
    profile: "Vardaan Hospital, Varanasi",
    address:
      "BHU Road, Near Newada Petrol Pump, Sundarpur, Newada, Varanasi, Uttar Pradesh 221005",
    timings: "Mon–Sat: 10:00 AM – 2:00 PM",
    mapQuery: "Vardaan Hospital, BHU Road, Sundarpur, Newada, Varanasi",
    reviewsUrl: null,
  },
];

export const reviewsLink = (clinic) =>
  clinic.reviewsUrl ||
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clinic.mapQuery)}`;

export const SITE_URL = "https://entsurgeonvaranasi.com";

export const IMAGES = {
  heroSurgery: "/images/hero-dr-teza-ot.webp",
  aboutDoctor: "/images/about-dr-teza.webp",
  microscopeSurgery: "/images/microscope-surgery.webp",
  modularOT: "/images/modular-ot.webp",
  endoscopy: "/images/endoscopy-stryker.webp",
  surgicalTeam: "/images/surgical-team.webp",
  entSurgery1: "/images/ent-surgery-1.webp",
  entSurgery2: "/images/ent-surgery-2.webp",
  entSurgery3: "/images/ent-surgery-3.webp",
};

export const GALLERY = [
  {
    src: "/images/hero-dr-teza-ot.webp",
    caption: "Dr. Sanjay Teza in the modular operation theatre, Varanasi",
  },
  {
    src: "/images/microscope-surgery.webp",
    caption: "Microscopic ear surgery using a Carl Zeiss operating microscope",
  },
  {
    src: "/images/endoscopy-stryker.webp",
    caption: "Minimally invasive endoscopic ENT surgery with Stryker HD imaging",
  },
  {
    src: "/images/surgical-team.webp",
    caption: "Dr. Teza with the ENT surgical team during a procedure",
  },
  {
    src: "/images/ent-surgery-1.webp",
    caption: "Precision ENT surgery under high-intensity OT lighting",
  },
  {
    src: "/images/modular-ot.webp",
    caption: "Fully equipped modular operation theatre setup",
  },
  {
    src: "/images/ent-surgery-2.webp",
    caption: "Focused microscopic surgery with the surgical team",
  },
  {
    src: "/images/ent-surgery-3.webp",
    caption: "Advanced head & neck surgery in progress",
  },
  {
    src: "/images/about-dr-teza.webp",
    caption: "Dr. Sanjay Teza — 25+ years of ENT surgical experience",
  },
];

export const EQUIPMENT = [
  {
    name: "Modular Operation Theatres",
    detail:
      "Fully modular, laminar-airflow OTs engineered for sterility, infection control and precision surgery.",
  },
  {
    name: "Carl Zeiss Operating Microscopes",
    detail:
      "Industry-leading optics enabling high-magnification microscopic ear and delicate tissue surgery.",
  },
  {
    name: "Advanced Stryker Endoscopic Systems",
    detail:
      "High-definition endoscopy for minimally invasive sinus, nasal and throat procedures.",
  },
];

export const WHY_CHOOSE = [
  {
    title: "25+ Years of Surgical Experience",
    detail:
      "Decades of focused ENT surgical practice across ear, nose, throat, head and neck.",
  },
  {
    title: "3,00,000+ Patients Treated",
    detail:
      "A proven track record built on consistent outcomes and patient trust in Varanasi.",
  },
  {
    title: "Evidence-Based & Ethical Care",
    detail:
      "Transparent diagnosis and treatment planning with no unnecessary procedures.",
  },
  {
    title: "Advanced Technology",
    detail:
      "Carl Zeiss microscopes, Stryker endoscopy and modular OTs for precise, minimally invasive surgery.",
  },
  {
    title: "Minimally Invasive Approach",
    detail:
      "Endoscopic and microscopic techniques for faster recovery and smaller incisions.",
  },
  {
    title: "Recognised Expertise",
    detail:
      "Health Legends Award & Dainik Jagran Wellness+ Healthcare Award recipient.",
  },
];

export const PATIENT_JOURNEY = [
  {
    step: "01",
    title: "Consultation",
    detail:
      "Detailed history, symptom review and a thorough ENT examination to understand your concern.",
  },
  {
    step: "02",
    title: "Accurate Diagnosis",
    detail:
      "Endoscopy, imaging and audiometry where required to pinpoint the exact cause.",
  },
  {
    step: "03",
    title: "Transparent Treatment Plan",
    detail:
      "Clear discussion of options, whether medical management or surgery, with honest guidance.",
  },
  {
    step: "04",
    title: "Precision Surgery",
    detail:
      "Advanced, minimally invasive surgery in modular OTs with modern equipment.",
  },
  {
    step: "05",
    title: "Recovery & Follow-up",
    detail:
      "Structured aftercare, follow-up visits and long-term outcome monitoring.",
  },
];
